import React, {Component} from 'react';
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {
    getPlans
} from '../modules/planReducer'
import {Card, Image, Grid, Dimmer, Loader, Segment, Divider, Container} from 'semantic-ui-react'

import 'semantic-ui-css/semantic.min.css';
import ReactPixel from 'react-facebook-pixel';

const options = {
    autoConfig: true, 	// set pixel's autoConfig
    debug: false, 		// enable logs
};

class Plan extends Component {
    constructor(props) {
        super(props)
        console.log(props)
    }

    componentWillMount() {
        this.props.getPlans()
        let advancedMatching = {}
        ReactPixel.init(process.env.REACT_APP_PIXEL_ID, advancedMatching, options);
        ReactPixel.pageView();
    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        if (this.props.plans.length === 0) {
            return (
                <div>

                    <Grid centered><h1>Plan</h1></Grid>
                    <Segment>
                        <Dimmer active>
                            <Loader indeterminate>Loading Plans</Loader>
                        </Dimmer>
                        <div>
                            <Card.Group centered>
                                <Card>
                                    <Card.Content>
                                        <Image size='tiny' floated='right' src='./assets/images/ma_trial.png'/>
                                        <Card.Header>
                                            Risk Free Trial
                                        </Card.Header>
                                        <Card.Meta>
                                            Free Videos and Reading Materials
                                        </Card.Meta>
                                        <Card.Description floated='center'>
                                            <strong>FREE</strong>
                                        </Card.Description>
                                    </Card.Content>

                                </Card>

                                <Card>
                                    <Card.Content>
                                        <Image size='tiny' floated='right' src='./assets/images/ma_lite.png'/>
                                        <Card.Header>
                                            LITE Program
                                        </Card.Header>
                                        <Card.Meta>
                                            Access to content and quizzes for the whole program
                                        </Card.Meta>
                                        <Card.Description>
                                            <strong>$29.00</strong> a month
                                        </Card.Description>
                                    </Card.Content>

                                </Card>
                                <Card>

                                    <Card.Content>
                                        <Image size='tiny' floated='right' src='./assets/images/ma_pro.png'/>
                                        <Card.Header>
                                            PRO Program
                                        </Card.Header>
                                        <Card.Meta>
                                            Access to the full program plus I monthly visit with a physician.
                                            Only available in NJ
                                        </Card.Meta>
                                        <Card.Description>
                                            <strong>$350.00</strong> a month
                                        </Card.Description>
                                    </Card.Content>

                                </Card>
                            </Card.Group>
                        </div>
                    </Segment>
                </div>
            )
        } else {
            console.log(this.props.plans)
            let getCardPlans = (plans) => {
                return plans.map(plan => {
                    let image = <Image size='tiny' floated='right' src='./assets/images/i_promotion@3.png'/>
                    if (plan.type === "gold")
                        image = <Image size='tiny' floated='right' src='./assets/images/i_pro@3.png'/>
                    else if (plan.type === "goldlite")
                        image = <Image size='tiny' floated='right' src='./assets/images/i_pro@3.png'/>
                    else if (plan.type === "silver")
                        image = <Image size='tiny' floated='right' src='./assets/images/i_lite@3.png'/>
                    else if (plan.type === "bronze")
                        image = <Image size='tiny' floated='right' src='./assets/images/i_trial@3.png'/>

                    return <Card key={plan.id} onClick={() => this.props.changePage(plan.type)}>
                        <Card.Content>
                            {image}
                            <Card.Header>
                                {plan.title}
                            </Card.Header>
                            <Card.Meta>
                                {plan.description}
                            </Card.Meta>
                            <Card.Description floated='center'>
                                $<strong>{plan.price}</strong> a month
                            </Card.Description>
                        </Card.Content>

                    </Card>
                })

            }
            return (
                <div>
                    <Container textAlign='justified'>
                        <br/>
                        <Grid centered><h1 style={{color: "white"}}>Plan</h1></Grid>
                        <br/>
                        <Divider horizontal>Choose your membership</Divider>

                        <Card.Group centered>
                            {getCardPlans(this.props.plans)}
                        </Card.Group>
                    </Container>
                    <br/>
                    <br/>
                </div>
            )
        }

    }
}

const mapStateToProps = state => ({plans: state.planReducer.plans})

const mapDispatchToProps = dispatch => bindActionCreators({
    getPlans,
    changePage: (type) => push('/register?type=' + type)
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Plan)


// WEBPACK FOOTER //
// ./src/containers/Plan.js